import { atom } from "jotai";

// An atom to hold the state of the loading spinner
export const errorModalAtom = atom<{
  isOpen: boolean;
  error: Error | unknown | undefined;
  textButton: string;
}>({
  isOpen: false,
  error: undefined,
  textButton: "Close",
});
